import { INotificationsState } from './../types';
import { createAction } from '@reduxjs/toolkit';

export const clearNotifications = createAction<{ notificationType: keyof INotificationsState }>(
  'CLEAR_NOTIFICATIONS'
);
